import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const PolicyHubPage = lazy(() =>
  import('../pages/policy-mgmt').then((m) => ({ default: m.PolicyHubPage }))
)
const PoliciesPage = lazy(() =>
  import('../pages/policy-mgmt').then((m) => ({ default: m.PoliciesPage }))
)
const AttestationsPage = lazy(() =>
  import('../pages/policy-mgmt').then((m) => ({ default: m.AttestationsPage }))
)
const ExceptionsPage = lazy(() =>
  import('../pages/policy-mgmt').then((m) => ({ default: m.ExceptionsPage }))
)
const PolicySearchPage = lazy(() =>
  import('../pages/policy-mgmt').then((m) => ({ default: m.PolicySearchPage }))
)
const PolicySettingsPage = lazy(() =>
  import('../pages/policy-mgmt').then((m) => ({ default: m.PolicySettingsPage }))
)
const PolicyMgmtAuditTrailPage = lazy(() =>
  import('../pages/policy-mgmt').then((m) => ({ default: m.PolicyMgmtAuditTrailPage }))
)

export const policyMgmtRoutes: RouteObject[] = [
  {
    path: '/policy-mgmt',
    children: [
      { index: true, element: <PolicyHubPage /> },
      { path: 'hub', element: <PolicyHubPage /> },
      { path: 'policies', element: <PoliciesPage /> },
      { path: 'attestations', element: <AttestationsPage /> },
      { path: 'exceptions', element: <ExceptionsPage /> },
      { path: 'search', element: <PolicySearchPage /> },
      { path: 'audit-trail', element: <PolicyMgmtAuditTrailPage /> },
      { path: 'settings', element: <PolicySettingsPage /> },
    ],
  },
]
